/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import ko from "knockout";

ko.components.register('loading-indicator', {
	viewModel: function(params) {
		params = params || {};
		this.loaded = params.loaded || false;
		this.error = ko.pureComputed(function() {
			return params.error ? ko.unwrap(params.error) : false;
		});
		this.title = ko.pureComputed(function() {
			var error = ko.unwrap(params.error);
			var title = ko.unwrap(params.title || 'Loading');
			return error ? error : title;
		});
	},
	template: require('../../../templates/shared/loading-indicator.html')
});
